import { AppError } from '@/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useErrorsStore = defineStore('ErrorsStore', () => {
  const appError = ref<AppError | null>(null)

  const clearAppError = () => {
    appError.value = null
  }

  const setAppError = (error: AppError) => {
    appError.value = error
  }

  return {
    appError,
    clearAppError,
    setAppError
  }
})
